import { ajax } from '../../../services/helper'

class ApiService {
    loginAuthentication = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/users/login"
            ajax(url, 'POST', data, false)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
}

export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/LoginPage/services/apiservices.js